import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import './ImageSlideshow.css';

const IMAGES = [
  { src: '/images/generalimg/home_page_row/img1.webp',  alt: 'LTF mentoring session' },
  { src: '/images/events-img/IMG_8502.webp',            alt: 'LTF community event' },
  { src: '/images/generalimg/home_page_row/img2.webp',  alt: 'LTF mentoring session' },
  { src: '/images/generalimg/home_page_row/img4.webp',  alt: 'LTF mentoring session' },
  { src: '/images/events-img/SigEp-Event-1.webp',       alt: 'LTF SigEp event' },
];

const ImageSlideshow = () => (
  <div className="imagerows">
    <Swiper
      effect="coverflow"
      grabCursor
      centeredSlides
      slidesPerView={4}
      spaceBetween={30}
      speed={3000}
      loop
      watchSlidesProgress
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      }}
      autoplay={{ delay: 0, disableOnInteraction: false }}
      pagination={false}
      modules={[Autoplay, EffectCoverflow]}
      breakpoints={{
        0:    { slidesPerView: 1.5 },
        480:  { slidesPerView: 2 },
        768:  { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      }}
    >
      {IMAGES.map((image, index) => (
        <SwiperSlide key={index}>
          <div className="col2">
            <img
              src={image.src}
              alt={image.alt}
              width="400"
              height="225"
              loading="lazy"
              decoding="async"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default ImageSlideshow;
